import * as React from 'react';
import { Form, Container } from 'react-bootstrap';
import _ from 'lodash'
import config from '../constants/config';
import { Redirect, useHistory, useLocation, useRouteMatch } from 'react-router-dom'

import { connect, useSelector, useDispatch } from "react-redux";
import * as actions from '../redux/actions'
import ButtonLoading from '../components/ButtonLoading';
import * as requestMethods from '../utils/RequestMethods'
import { Button, Typography, Card, CardContent, Box, Grid, InputAdornment, IconButton } from '@mui/material';
import TextFieldValidate from '../components/TextFieldValidate';
import { isEmail, validatePassword } from '../utils/validator';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CustomNavLink from '../components/CustomNavLink';
import { IAppState } from '../redux/reducers'
import { copyObject } from '../utils';
import { getQueryStringParams } from '../utils/utilsT';
interface Props {

}

const LoginScreen: React.FunctionComponent<Props> = (): JSX.Element => {
  const auth = useSelector((state: IAppState) => state.auth)
  const dispatch = useDispatch()
  let match = useRouteMatch();
  const [email, setEmail] = React.useState(copyObject(config.testEmail))
  const [password, setPassword] = React.useState(copyObject(config.testPassword))
  const [showLoginErrorMessage, setShowLoginErrorMessage] = React.useState(false)
  let btnLogin = React.useRef(null)
  const [showPassword, setShowPassword] = React.useState(false)
  const [validated, setValidated] = React.useState(false);
  let history = useHistory()
  // const { params } = useLocation()


  React.useEffect(() => {
    const params = getQueryStringParams(history.location.search)
    console.log("params", params)
    if (_.has(params, "email")) {
      setEmail(params?.email)

    }
    if (_.has(params, "password")) {
      setPassword(params?.password)
    }
  }, []);
  /**
   *
   * @param event
   */
  const login = async (event): Promise<string> => {
    event.preventDefault();
    setValidated(true)
    if (email == "" || !isEmail(email) || password == "") {

      throw new Error("Please check and input correct fields!");
    }

    let params = {
      email: email,
      password: password,
    };

    return await requestMethods.AxiosInstance.post(`${config.url.wpJson}/wp/v2/token`, params).then((res) => {
      if (res && res.data) {
        let msg = res.data.message ? res.data.message : "";
        // @ts-ignore
        dispatch(actions.loginSuccess(res.data)).then(() => {
          actions.asyncUserData()
        })
        return "Logging in."
      }
    }).catch((error) => {
      throw error;
    })

  };

  const removeErrorStyling = () => {
    setShowLoginErrorMessage(false)
  }
  /**
      *
      * @param match
      */
  const getBaseUrl = (match) => {
    let url = match.url
    return url.replace(/\/[0-9]+$/g, '');
  }


  const naviagte = (path: string, search: string = ""): void => {
  
    history.push({
      pathname: `${path}`,
      search: search,

    });
  }

  if (auth.token) {
    return <Redirect to='/jobs' />
  }
  return (

    <Container className="App" style={{ marginTop: "10vh" }}>
      <Box className=" d-flex  justify-content-center  mb-2">

        <Card className="  col-md-8" style={{}}>
          <CardContent>

            <Form onSubmit={login} style={{ padding: "20px" }}>
              <Typography variant="h5">Login</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>

                  <TextFieldValidate
                    fullWidth
                    required
                    variant="standard"
                    autoComplete={'off'}
                    name="email"
                    label="Email"
                    type="email"
                    value={`${email}`}
                    onChange={(event: any) => {
                      let value = event.target.value
                      setEmail(value)
                    }}
                    validated={validated}
                    onValidateError={(value) => {
                      if (value == "") {
                        return "Required"
                      }
                      if (!isEmail(value)) {
                        return "Invalid email"
                      }
                      return ""
                    }}
                  />
                </Grid>
                <Grid item xs={12}>

                  <TextFieldValidate

                    fullWidth
                    required
                    label="Password"
                    variant="standard"
                    type={showPassword ? 'text' : 'password'}
                    InputProps={{
                      // disableUnderline: true,
                      endAdornment: (<InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={(event) => {
                            event.preventDefault();
                          }}
                          onMouseDown={(e) => {
                            setShowPassword(!showPassword)
                          }}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>)
                    }}
                    className={`  `}
                    value={`${password}`}
                    validated={validated}

                    onChange={(event: any) => {
                      let value = event.target.value
                      setPassword(value)
                    }}

                    //    autoComplete={"false"}
                    onValidateError={(value) => {
                      if (value == "") {
                        return "Required"
                      }

                      return ""
                    }}
                  />
                </Grid>
                {/* <Grid>
              <Form.Group controlId="formBasicChecbox">
                <Form.Check type="checkbox" label="Remember me" />
              </Form.Group>

              </Grid> */}
                <Grid item xs={12}>
                  <ButtonLoading
                    customButton={Button}
                    customButtonProps={{
                      fullWidth: true,
                      variant: "contained",
                      color: "success",
                      size: "large"
                    }}
                    onClickFetching={login}
                    // className="btn-primary btn-block"
                    // style={{ color: "#fff" }}
                    type="submit"
                  >
                    <Typography variant="button" color="#fff">Login</Typography>
                  </ButtonLoading>
                </Grid>

                <Grid item xs={12}>
                  <Button variant='contained' fullWidth LinkComponent={"a"} href='/register?action=registerClient' onClick={(e) => {
                    e.preventDefault()
                    naviagte("register", '?action=registerClient')
                  }} >Start Your Move</Button>
                </Grid>
                <Grid item xs={12}>
                  <CustomNavLink to="/register">Create Account</CustomNavLink>
                </Grid>
                <Grid item xs={12}>
                  <CustomNavLink to="/forgot-password">Forgot password?</CustomNavLink>
                  {/* <a href="/forgot-password">Forgot password?</a> */}
                </Grid>

              </Grid>
            </Form>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );

}


export default LoginScreen;
//export { LoginScreen };
